import { createAction } from '@reduxjs/toolkit';

export const inviteFriendsRequest = createAction<{ message?: string }>('invites/request');
export const inviteFriendsSuccess = createAction<{ recipientIds: string[] }>('invites/success');
export const inviteFriendsFailure = createAction<string>('invites/failure');
